import React from 'react';
import { ComponentMeta, ComponentStory } from '@storybook/react';

import FormField from './FormField';
import Input from '../Input';

export default {
  title: 'FormField',
  component: FormField,
} as ComponentMeta<typeof FormField>;

const Template: ComponentStory<typeof FormField> = args => (
  <div style={{ width: '500px' }}>
    <FormField {...args} />
  </div>
);

const commonProps = {
  children: [<Input />],
};

export const Basic = Template.bind({});
Basic.args = {
  ...commonProps,
  label: 'Basic FormField',
};
